import React from 'react';
import cn from 'classnames';
import style from './cubbyCheckList.module.scss';
import SlotContent from '../CubbySlot/SlotContent/index';
import SearchIcon from '../../../../assets/images/Fireboard/Search';
import { ReactComponent as CrossIcon } from '@assets/images/Fireboard/crossIcon.svg';
import { ReactComponent as NoteIcon } from '@assets/images/Fireboard/noteIcon.svg';

const cubbyChecksList = props => {
  const {
    checklist,
    checksForAssignment,
    onSelecteCheckForAssignment,
    handleShowCheckDetails,
    searchFieldValue,
    setSearchFieldValue,
    checkSortFunc,
    ascendingCheck,
  } = props;
  const showCheck = check => {
    const [order0] = check?.orders || [];
    const { storeCubbySlotId, pickUpStatus } = order0 || [];
    return pickUpStatus === 0 && !storeCubbySlotId;
  };

  const displayName = check => check?.tabName || check?.orderDetails?.orderName || check?.deliverTo;
  return (
    <div className={cn('w-100', style.containerBorder)}>
      <div className="d-flex position-relative mb-3">
        <input
          type="text"
          value={searchFieldValue}
          onChange={e => setSearchFieldValue(e.target.value)}
          className={cn(style.searchInput, 'col-12 px-2')}
          placeholder="Search here"
        />
        {searchFieldValue ? (
          <div
            className={style.crossIcon}
            onClick={() => setSearchFieldValue('')}
          >
            <CrossIcon />
          </div>
        ) : (
          <div className={style.searchIcon}>
            <SearchIcon />
          </div>
        )}
      </div>

      <div className={cn('overflowY', style.cubbyCheckListWrapper)}>
        {checklist?.map(
          (check, index) =>
            showCheck(check) && (
              <div
                className={cn(
                  'col-12 px-0 fw-500',
                  style.tile,
                  checklist.length - 1 !== index && 'mb-2',
                  checksForAssignment?.has(check.checkHeaderId) &&
                    style.selectedCheckTile
                )}
                key={check.id}
                onClick={() =>
                  onSelecteCheckForAssignment &&
                  onSelecteCheckForAssignment(check)
                }
              >
                <div
                  className={cn(
                    'col-12 px-2 d-flex justify-content-between align-items-center position-relative',
                    style.tileHeader
                  )}
                >
                  <span
                    className={cn(
                      'col-12 px-1 text-center',
                      displayName(check)?.length > 13 ?
                       style.truncate
                        : ''
                    )}
                  >
                    {displayName(check)}
                  </span>
                  <div
                    className={cn(style.moreIcon)}
                    onClick={() => handleShowCheckDetails(check)}
                  >
                    <NoteIcon />
                  </div>
                </div>
                <div className="col-12 px-2 py-1 d-flex align-items-center">
                  <SlotContent
                    check={check}
                    showDeliveryVendor={false}
                    showMarketplaceVendor={false}
                    showPickupTime={true}
                  />
                </div>
              </div>
            )
        )}
      </div>
    </div>
  );
};

export default cubbyChecksList;
